<template>
    <div class="d-flex align-center justify-space-around" v-if="prices" style="min-width: 60px">
        <v-tooltip top v-if="appCurrency !== currencies.uah" class="mr-4">
            <template v-slot:activator="{ on, attrs }">
                <span
                        class="teal--text"
                        style="font-size: 21px"
                        v-bind="attrs"
                        v-on="on"
                >
                    &#8372;
                </span>
            </template>
            <span>{{ priceUah }} {{ this.currencies.uah.toUpperCase() }}</span>
        </v-tooltip>
        <v-tooltip top v-if="appCurrency !== currencies.usd" class="mr-4">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                        color="teal"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="mr-4"
                >attach_money</v-icon>
            </template>
            <span>{{ priceUsd }} {{ this.currencies.usd.toUpperCase() }}</span>
        </v-tooltip>
        <v-tooltip top v-if="appCurrency !== currencies.eur">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                        color="teal"
                        dark
                        v-bind="attrs"
                        v-on="on"
                >
                    euro_symbol
                </v-icon>
            </template>
            <span>{{ priceEur }} {{ this.currencies.eur.toUpperCase() }}</span>
        </v-tooltip>
    </div>
</template>

<script>
    export default {
        name: "CurrencyTooltips",
        props: ['prices', 'pack'],
        data() {
            return {
                currencies: {
                    uah: this.$store.state.currency[0].name,
                    usd: this.$store.state.currency[1].name,
                    eur: this.$store.state.currency[2].name
                },
                priceUnoUAH: null,
                priceUnoUSD: null,
                priceUnoEUR: null,
            }
        },
        computed: {
            appCurrency() {
                return this.$store.state.appCurrency;
            },
            priceUah() {
                return this.prices.uah.toFixed(2) || this.$t('contractual');
            },
            priceUsd() {
                return this.prices.usd.toFixed(2) || this.$t('contractual');
            },
            priceEur() {
                return this.prices.eur.toFixed(2) || this.$t('contractual');
            }
        }
    }
</script>

<style scoped>

</style>
